const data = {
	"width": 36,
	"height": 36,
	"body": "<path fill=\"currentColor\" d=\"M33 11H3a1 1 0 0 0 0 2h30a1 1 0 0 0 0-2Z\" class=\"clr-i-outline clr-i-outline-path-1\"/><path fill=\"currentColor\" d=\"M28 17H8a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2Z\" class=\"clr-i-outline clr-i-outline-path-2\"/><path fill=\"currentColor\" d=\"M23 23H13a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z\" class=\"clr-i-outline clr-i-outline-path-3\"/><path fill=\"none\" d=\"M0 0h36v36H0z\"/>"
};
exports.__esModule = true;
exports.default = data;
